(function () {
    'use strict';

    angular
        .module('externalPartyEditRoutes', ['oddRoutes', 'externalPartyEditModule'])
        .config(router);

    router.$inject = ['$stateProvider'];

    function router($stateProvider) {

        $stateProvider

            // Edit External Party
            .state('odd.externalPartyEdit', {
                url: '/ExternalParty/{ODDExternalPartyID:int}',
                resolve: {
                    externalParty: ['$stateParams','businessUnit', function ($stateParams, businessUnit) {
                        return _.find(businessUnit.ODDExternalParties, {ODDExternalPartyID: $stateParams.ODDExternalPartyID});
                    }]
                },
                views: {
                    'externalParties@odd': {
                        controller: 'ODDExternalPartyEditController',
                        templateUrl: require('./externalPartyEdit.tpl.html'),
                        resolve: {
                            campaigns: ['$stateParams', 'oddCampaignService', 'businessUnit', function ($stateParams, service, businessUnit) {
                                return service.getAllCampaignsByBusinessUnitAndExtParty(businessUnit.ODDBusinessUnitID, $stateParams.ODDExternalPartyID);
                            }]
                        }
                    }
                }
            })

            // Create External Party
            .state('odd.addExternalParty', {
                parent: 'odd.campaignStatusMgmt',
                url: '/Add',
                views: {
                    'externalParties@odd': {
                        controller: 'ODDExternalPartyAddController',
                        templateUrl: require('./externalPartyAdd.tpl.html')
                    }
                }
            })

            .state('odd.externalPartyEdit.addCampaign', {
                url: '/Campaign/Add',
                resolve: {
                    campaign: ['$stateParams', 'businessUnit', function ($stateParams, businessUnit) {
                        return {
                            ODDBusinessUnitID: businessUnit.ODDBusinessUnitID,
                            ODDExternalPartyID: $stateParams.ODDExternalPartyID
                        };
                    }]
                },
                views: {
                    'externalParties@odd': {
                        controller: 'ODDCampaignEditController',
                        templateUrl: require('./campaignEdit.tpl.html')
                    }
                }
            })

            .state('odd.externalPartyEdit.campaign', {
                url: '/Campaign/{ODDCampaignID:int}',
                resolve: {
                    campaign: ['$stateParams', 'oddCampaignService', 'businessUnit', function ($stateParams, service, businessUnit) {
                        return service.getCampaign(businessUnit.ODDBusinessUnitID, $stateParams.ODDCampaignID);
                    }]
                },
                views: {
                    'externalParties@odd': {
                        controller: 'ODDCampaignEditController',
                        templateUrl: require('./campaignEdit.tpl.html')
                    }
                }
            })

            .state('odd.externalPartyEdit.campaign.inviteDetails', {
                url: '/InviteDetails',
                views: {
                    'externalParties@odd': {
                        controller: 'ODDCampaignInviteDetailsEditController',
                        templateUrl: require('./campaignInviteDetailsEdit.tpl.html')
                    }
                }
            })

            .state('odd.externalPartyEdit.campaign.editObservationList', {
                url: '/Observations',
                resolve: {
                    observations: ['recomService', 'campaign', function (service, campaign) {
                        return service.getObservationsByCampaign(campaign.ODDCampaignID);
                    }]
                },
                views: {
                    'externalParties@odd': {
                        controller: 'ODDCampaignObservationListController',
                        templateUrl: require('./campaignObservationListEdit.tpl.html')
                    }
                }
            })

            .state('odd.externalPartyEdit.campaign.editQuestionnaireList', {
                url: '/Questionnaires',
                views: {
                    'externalParties@odd': {
                        controller: 'ODDCampaignQuestionnaireListEditController',
                        templateUrl: require('./campaignQuestionnaireListEdit.tpl.html')
                    }
                }
            })

            .state('odd.externalPartyEdit.campaign.questionnaire', {
                url: '/Questionnaire/{ODDCampaignQuestionnaireID:int}',
                resolve: {
                    questionnaire: ['$stateParams', 'oddCampaignService', 'businessUnit', function ($stateParams, service, businessUnit) {
                        return service.getQuestionnaire(businessUnit.ODDBusinessUnitID, $stateParams.ODDExternalPartyID, $stateParams.ODDCampaignID,
                            $stateParams.ODDCampaignQuestionnaireID);
                    }]
                },
                views: {
                    'externalParties@odd': {
                        controller: 'ODDCampaignQuestionnaireEditController',
                        templateUrl: require('./campaignQuestionnaireEdit.tpl.html')
                    }
                }
            })

            .state('odd.externalPartyEdit.campaign.questionnaire.editSectionList', {
                url: '/Sections',
                views: {
                    'externalParties@odd': {
                        controller: 'ODDCampaignQuestionnaireSectionListEditController',
                        templateUrl: require('./campaignQuestionnaireSectionListEdit.tpl.html')
                    }
                }
            });
    }
})();